/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Publisheddone1Inputs */

const en_publisheddone1 = /** @type {(inputs: Publisheddone1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Published`)
};

const de_publisheddone1 = /** @type {(inputs: Publisheddone1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veröffentlicht`)
};

/**
* | output |
* | --- |
* | "Published" |
*
* @param {Publisheddone1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const publisheddone1 = /** @type {((inputs?: Publisheddone1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publisheddone1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_publisheddone1(inputs)
	return de_publisheddone1(inputs)
});
export { publisheddone1 as "publishedDone" }